import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { ComposeViewState } from 'owa-mail-compose-store';
import { lazyCloseCompose, isViewStateDirty } from 'owa-mail-compose-store';
import strings from 'owa-strings/owa-mail-strings';

export const closeItem = (viewState: ComposeViewState) => (): void => {
    confirm(
        strings.closeMessage,
        strings.addinCloseCompose,
        !isViewStateDirty(viewState) /* Resolve Immediately */,
        {
            okText: strings.closeButton,
            hideCancelButton: false,
        }
    ).then((result: DialogResponse) => {
        if (result == DialogResponse.ok) {
            lazyCloseCompose.importAndExecute(viewState);
        }
    });
};
